import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Form, Input } from 'antd';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { CUSTOMISE_BUTTONS_CONST } from 'configs/localData/constant';
import { editAppSettingsCentre, getByIdCentres } from 'redux/centres/actions';
import { useDispatch } from 'react-redux';
import CentreModal from '.';

const CustomiseButtonsModal = forwardRef(({ id }, ref) => {
  const [loading, setLoading] = useState();

  const [visible, setVisible] = useState();

  const [form] = Form.useForm();

  const dispatch = useDispatch();

  useImperativeHandle(
    ref,
    () => ({
      open: (initialValue) => {
        setVisible(true);
        form.setFieldsValue(initialValue);
      },
    }),
    [form],
  );

  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  const onOk = () => {
    form.validateFields().then((values) => {
      setLoading(true);
      dispatch(
        editAppSettingsCentre({
          id,
          data: values,
        }),
      )
        .then(({ payload }) => {
          if (payload?.isSuccess) {
            dispatch(
              getByIdCentres({
                data: { id },
              }),
            );
            handleCancel();
          }
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  return (
    <CentreModal
      title={i18next.t('centreDetail.customiseButtons')}
      onCancel={handleCancel}
      onOk={onOk}
      loading={loading}
      visible={visible}
    >
      <div>
        <Form form={form}>
          <Form.Item
            name={CUSTOMISE_BUTTONS_CONST.applyBtn.key}
            label={i18next.t('button.apply')}
            className="form-item-empty-label"
            rules={[
              {
                type: 'url',
                message: i18next.t('error.url'),
              },
            ]}
          >
            <Input placeholder={i18next.t('input.apply.placeholder')} />
          </Form.Item>

          <Form.Item
            name={CUSTOMISE_BUTTONS_CONST.bookATourOrVisit.key}
            label={i18next.t('button.bookATourOrVisit')}
            className="form-item-empty-label"
            rules={[
              {
                type: 'url',
                message: i18next.t('error.url'),
              },
            ]}
          >
            <Input
              placeholder={i18next.t('input.bookATourOrVisit.placeholder')}
            />
          </Form.Item>
        </Form>
      </div>
    </CentreModal>
  );
});

CustomiseButtonsModal.propTypes = {
  id: PropTypes.string,
};

CustomiseButtonsModal.defaultProps = {};

export default CustomiseButtonsModal;
